import { Styles } from '@chakra-ui/theme-tools';

export const GlobalStyles: Styles = {
  global: {
    p: {
      color: 'gray.700',
    },
  },
};
